import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { mapState } from 'vuex';
import { getTransportList, getTransportDetail, addTransport, updateTransport, deleteTransport, changeTransportStatus } from '@/services/sendtypesetting';
export default {
  name: 'sendtypesetting',
  i18n: require('./i18n-sendtypesetting'),
  components: {},
  data: function data() {
    return {
      //默认语言
      defaultLangObj: {},
      //系统设置中选择的语言
      langList: [],
      initialLangDataList: [],
      //上传图片用
      action: '',
      imageUrl: '',
      updateData: {},
      loading: false,
      queryLoading: false,
      errTip: this.$t('public.enterPlease') + this.$t('sendtypesetting.sendtypeName'),
      //列表数据
      tableDataList: [],
      isTableLoading: false,
      dialogStatus: '',
      //新建/修改状态位
      textMap: {
        //新建/修改title
        create: this.$t('sendtypesetting.sendtypeNew'),
        update: this.$t('sendtypesetting.sendtypeEdit')
      },
      visible: false,
      //新建/修改 显示
      host: "",
      confirmLoading: false,
      modalValue: {
        id: "",
        langDataList: [],
        pictureUrl: ""
      }
    };
  },
  computed: {},
  created: function created() {
    this.action = process.env.VUE_APP_API_BASE_URL + "/common/upload/";
    this.updateData = {
      type: 7
    };
    this.getInitialValue();
    this.getList();
  },
  methods: {
    //获取localStorage里面的默认语言和系统设置中存的语言list
    getInitialValue: function getInitialValue() {
      var self = this;
      self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
      self.langList = JSON.parse(localStorage.getItem('langList'));
      var _iterator = _createForOfIteratorHelper(self.langList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var nameObj = {};
          //标题
          nameObj.titleName = self.$t('sendtypesetting.sendtypeName') + '(' + item.langName + ')';
          //多语言id
          nameObj.langId = item.langId;
          //名称
          nameObj.title = "";
          if (item.langId == self.defaultLangObj.langId) {
            nameObj.required = true;
          } else {
            nameObj.required = false;
          }
          self.initialLangDataList.push(nameObj);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      self.modalValue.langDataList = _.cloneDeep(self.initialLangDataList);
    },
    //获取列表
    getList: function getList() {
      var self = this;
      self.isTableLoading = true;
      getTransportList().then(function (res) {
        //				 console.log(res.data)
        if (res.data.code == 200) {
          self.tableDataList = res.data.data;
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      }).finally(function () {
        self.isTableLoading = false;
      });
    },
    /* 编辑按钮 */updata: function updata(record) {
      var _this = this;
      var self = this;
      self.queryLoading = true;
      this.dialogStatus = 'update';
      this.visible = true;
      this.imageUrl = '';
      //获取详情数据
      self.modalValue.langDataList = _.cloneDeep(self.initialLangDataList);
      getTransportDetail(record.id).then(function (res) {
        //				 	console.log(res.data)
        if (res.data.code == 200) {
          var rs = res.data.data;
          self.modalValue.id = rs.id;
          self.modalValue.pictureUrl = rs.pictureUrl;
          self.host = rs.host;
          self.imageUrl = rs.host + rs.pictureUrl;
          //给多语言集合赋值
          rs.langDataList.forEach(function (item, index) {
            self.modalValue.langDataList.forEach(function (itemModal, index) {
              if (item.langId == itemModal.langId) {
                itemModal.title = item.title;
              }
            });
          });
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      }).finally(function () {
        _this.queryLoading = false;
      });
    },
    /* 添加按钮 */addModal: function addModal() {
      this.dialogStatus = 'create';
      this.visible = true;
      this.resetmodalValue();
    },
    /* 取消按钮 */resetFormDate: function resetFormDate() {
      this.visible = false;
      this.resetmodalValue();
    },
    resetmodalValue: function resetmodalValue() {
      var self = this;
      self.modalValue = {
        id: "",
        langDataList: _.cloneDeep(self.initialLangDataList),
        pictureUrl: ""
      };
      //this.$refs.ruleForm.resetFields();
    },
    /* 确定添加 */saveModal: function saveModal() {
      var _this2 = this;
      console.log(123);
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this2.visible = false;
          //调接口
          addTransport(_this2.modalValue).then(function (result) {
            if (result.data.code == 200) {
              _this2.getList();
              _this2.$message.success(_this2.$t('public.saveSuccessfully'));
            } else {
              // this.$message.error(result.data.message);
              return false;
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /* 确定更新 */updateModal: function updateModal() {
      var _this3 = this;
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this3.confirmLoading = true;
          //调接口
          updateTransport(_this3.modalValue).then(function (result) {
            if (result.data.code == 200) {
              _this3.getList();
              _this3.visible = false;
              _this3.$message.success(_this3.$t('public.saveSuccessfully'));
            } else {
              // this.$message.error(result.data.message);
              return false;
            }
          }).finally(function () {
            _this3.confirmLoading = false;
          });
        } else {
          return false;
        }
      });
    },
    confirm: function confirm(record) {
      var _this4 = this;
      var params = 1 - record.transportStatus;
      if (record.changeTransportStatusLoading) return;
      record.changeTransportStatusLoading = true;
      changeTransportStatus(record.id, params).then(function (result) {
        if (result.data.code == 200) {
          _this4.$message.success(_this4.$t('public.updateSuccessfully'));
          _this4.getList();
        } else {
          // this.$message.error(result.data.message);
          return false;
        }
      }).finally(function () {
        record.changeTransportStatusLoading = false;
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('You can only upload JPG file!');
      }
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('Image must smaller than 2MB!');
      }
      return isJpgOrPng && isLt2M;
    },
    handleChange: function handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (info.file.status === 'done') {
        if (info.file.response.code == 200) {
          var picurl = info.file.response.data.uploadfilepath;
          var urlpath = info.file.response.data.urlpath;
          this.imageUrl = urlpath + picurl;
          this.modalValue.pictureUrl = info.file.response.data.uploadfilepath;
          this.loading = false;
          console.log(info, 'info...............');
        }
      }
    }
  }
};